/**
 * 事業所回答フォーム（town アプリ）のベースURL。
 * 環境変数で指定し、環境ごとに変更する。
 *
 * - Vite 利用時（school / admin 等）: .env に VITE_TOWN_FORM_BASE_URL を設定
 *   例: VITE_TOWN_FORM_BASE_URL=http://localhost:5175（開発）
 *   例: VITE_TOWN_FORM_BASE_URL=https://town.example.com（本番）
 * - Node 利用時（テスト等）: process.env.VITE_TOWN_FORM_BASE_URL または TOWN_FORM_BASE_URL
 */
export function getTownFormBaseUrl(): string {
  const env = (import.meta as unknown as { env?: Record<string, string> }).env
  if (typeof import.meta !== 'undefined' && env?.VITE_TOWN_FORM_BASE_URL) {
    return env.VITE_TOWN_FORM_BASE_URL
  }
  if (typeof process !== 'undefined' && process.env?.VITE_TOWN_FORM_BASE_URL) {
    return process.env.VITE_TOWN_FORM_BASE_URL
  }
  if (typeof process !== 'undefined' && process.env?.TOWN_FORM_BASE_URL) {
    return process.env.TOWN_FORM_BASE_URL
  }
  return ''
}
